import React from "react"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { dbg } from "../../utils/general.utils"

/**
 * @typedef {import("prop-types").InferProps<typeof propTypes>} PropTypes
 * @param {Omit<import("react-router-dom").LinkProps, keyof PropTypes | "to"> & PropTypes} props
 * @returns
 */
const ClientBudgetLink = ({ state, ...props }) => {
  dbg(() => {
    console.assert(!isNaN(state?.id), "id is NaN")
  })

  return (
    <Link
      to="/administracion/clientes/presupuesto-cliente"
      state={state}
      {...props}
    />
  )
}

const propTypes = {
  state: PropTypes.shape({
    id: PropTypes.number.isRequired,
    highlightBudgetId: PropTypes.string,
  }),
}

ClientBudgetLink.propTypes = propTypes

export default ClientBudgetLink
